import React, { Component } from 'react';

import classNames from 'classnames';
import { I18n } from 'components/translate';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { PropTypes } from 'prop-types';

import TooltipPortal from './TooltipPortal';

import './InfoTooltip.scss';

@inject('UiStore')
@observer
export default class InfoTooltip extends Component {
  static propTypes = {
    id: PropTypes.string,
    position: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string,
    UiStore: MobxPropTypes.objectOrObservableObject,
    rerenderPosition: PropTypes.bool,
    disableTranslate: PropTypes.bool,
    children: PropTypes.node
  };

  static defaultProps = {
    position: 'right',
    rerenderPosition: false,
    disableTranslate: false
  };

  state = {
    style: {}
  };

  componentDidMount() {
    this.setTooltipPosition();
  }

  setTooltipPosition() {
    if (this.isMobile) {
      const rect = this.tooltip.getBoundingClientRect();

      this.setState({
        style: { transform: `translate3d(-${rect.left}px, 0, 0)` }
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rerenderPosition !== this.props.rerenderPosition) {
      this.setTooltipPosition();
    }
  }

  get isMobile() {
    const { gridSize } = this.props.UiStore;

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return gridSize < 576;
  }

  render() {
    const { id, position, text, className, disableTranslate, children } =
      this.props;

    const classComponent = classNames(
      'tooltip__info__message',
      { 'tooltip--center': position === 'center' && !this.isMobile },
      { 'tooltip--right': position === 'right' && !this.isMobile },
      { 'tooltip--mobile': this.isMobile },
      className
    );

    const tooltipId = id || Math.random();

    return (
      <span
        ref={(node) => (this.tooltip = node)}
        className="tooltip__info"
        id={`tooltip-${tooltipId}`}
      >
        {children ? (
          children
        ) : (
          <div className="tooltip__icon">
            <i className="icon icon-question" />
          </div>
        )}
        <TooltipPortal
          parentId={`tooltip-${tooltipId}`}
          className={classComponent}
          style={this.state.style}
        >
          {disableTranslate ? text : <I18n label={text} />}
        </TooltipPortal>
      </span>
    );
  }
}
